<template>
    <div id="awards" class="container">
      <div class="section-title">جوائــز وإنجـــازات</div>
      <ul>
        <li v-for="(award,index) in awards" v-if="index <= nAwards" :key="award.id">
          <img :src="'https://cms.zaidounk.com/'+award.awardImage" alt="">
          <div class="award-name" v-html="award.awardName"></div>
          <div class="spacer"></div>
        </li>
      </ul>
      <div class="load-more" v-if="loadMoreCheck" @click="loadMore">المزيد</div>
    </div>
</template>

<script>
export default {
  data () {
      return {
        awards: '',
        nAwards: 7,
        loadMoreCheck:true,
        windowWidth:''
      }
  },
  computed: {
    getWindowWidth() {
        this.windowWidth = document.documentElement.clientWidth;
    },
    getnAwards(){
      if(this.windowWidth < 767){
        this.nAwards = 5
      } else{
        this.nAwards = 8
      }
    }
  },
  methods: {
    loadMore(){
      this.nAwards = this.nAwards + 3
      if (this.awards.length <= this.nAwards ){
        this.loadMoreCheck = false;
      }
    }
  },
  created () {
    this.$http.get('https://cms.zaidounk.com/api/awards')
    .then(result => {
        return result.json()
    })
    .then(data => {
        this.awards = data
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sections/Awards.vue